/**
 * JSON schema version for the analytics timeline output.
 */
export const SCHEMA_VERSION = '1.3.0';
